module.exports = __webpack_public_path__ + "r-v3/img/info_white.fa115407.svg";